<template>
  <span @click="$emit('click', $event.target.value)" class="XVcheckbox pointer">
    <span v-focus="focus" class="radioholder" v-on:click="clickcheck()">
      <span class="squaredFour pointer" >
        <input v-bind="$attrs" :disabled="disabled" :checked="checked" type="checkbox">   
        <label></label>     
      </span>
    </span>
  </span>

</template>

<script>


export default {
  inheritAttrs: false,
  name: 'XVcheckbox',
  props: {
      focus: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        required: true
      },
      value: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      formdata: {}
  },
  data: function () {
    return {
      checked: false
    }
  },
  watch: {  
    value: function(){
      if (this.value !== undefined){
        this.checked = this.value
      }
    }
  },  
  methods: {
    clickcheck: function(){      
        if (this.disabled === true){
          return false
        }
        this.checked = !this.checked
        this.$emit('input', this.checked) // prop value en deze input event handler zorgen er voor dat je een v-model kan toepassen op dit custom component
        this.$emit('formvaluechanged',
          {
            type: this.$vnode.componentOptions.tag,
            value: this.checked,
            id: this.id,
            formdata: this.formdata
          }
        )
    }
  },
  mounted: function () {
    if (this.value !== undefined){
      this.checked = this.value
    }
  }

}
</script>
